import { buildPagingLiteral, buildWhereLiteral } from '@/lib/graphql-query-builder';

// Both lists are read page by page, so they page in a fixed order (the service sorts them itself).
const PAGING_ORDER = '[{ field: "CreatedDate", direction: ASC }]';

// This module has no schema of its own — it composes the real "LeaveRequest"
// and "Holiday" schemas client-side (see services/leave-calendar.service.ts
// and types/leave-calendar.types.ts for why).
export const buildGetLeaveRequestsForCalendarQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    LeaveRequests: getLeaveRequests(
      where: ${buildWhereLiteral(where)}
      order: ${PAGING_ORDER}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      totalCount
      items {
        ItemId
        Title
        UserId
        DisplayName
        ProfileImageId
        LeaveCategory
        LeaveCategoryId
        LeaveType
        StartDate
        EndDate
        Status
        IsDocumentSendByDr
        CreatedDate
        Timezone
      }
    }
  }
`;

export const buildGetHolidaysForCalendarQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    Holidays: getHolidays(
      where: ${buildWhereLiteral(where)}
      order: ${PAGING_ORDER}
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      totalCount
      items {
        ItemId
        Name
        StartDate
      }
    }
  }
`;
